import { ByteStreamWriter, UID_BYTES_PER_ELEMENT, ServerBufferMessageType } from "flavr-common";
let cachedKeepAliveBuffer;
export function createKeepAliveBuffer() {
    if (cachedKeepAliveBuffer)
        return cachedKeepAliveBuffer;
    cachedKeepAliveBuffer = new ArrayBuffer(Uint8Array.BYTES_PER_ELEMENT);
    const stream = new ByteStreamWriter(cachedKeepAliveBuffer);
    stream.uint8(ServerBufferMessageType.Keepalive);
    return cachedKeepAliveBuffer;
}
export function createChangeRoomBuffer(roomUid) {
    const buffer = new ArrayBuffer(Uint8Array.BYTES_PER_ELEMENT + UID_BYTES_PER_ELEMENT);
    const stream = new ByteStreamWriter(buffer);
    stream.uint8(ServerBufferMessageType.ChangeRoom);
    stream.uid(roomUid);
    return buffer;
}
